import {
  targetGroupsByVersionConstants,
  createTargetGroupsByVersionConstants,
  editTargetGroupsByVersionConstants,
  addTargetGroupsByVersionConstants,
  removeTargetGroupsByVersionConstants,
  deleteTargetGroupsByVersionConstants,
} from "../_redux-constants";
import { targetGroupsVersionService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getTargetGroupsByVersion(requestBody, queryParams) {
  function getTargetGroupsByVersionLoad() {
    return {
      type: targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function getTargetGroupsByVersionSuccess(data) {
    return {
      type: targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function getTargetGroupsByVersionFailure(error) {
    return {
      type: targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsByVersionLoad());
    return targetGroupsVersionService
      .getTargetGroupsByVersion(requestBody, queryParams)
      .then(
        (data) => {
          dispatch(getTargetGroupsByVersionSuccess(data));
        },
        (error) => {
          dispatch(getTargetGroupsByVersionFailure(error?.toString()));
        }
      );
  };
}

function createTargetGroupsByVersion(requestBody) {
  function createTargetGroupsByVersionLoad() {
    return {
      type: createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function createTargetGroupsByVersionSuccess(data) {
    return {
      type: createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function createTargetGroupsByVersionFailure(error) {
    return {
      type: createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createTargetGroupsByVersionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVersionService.createTargetGroupsByVersion(requestBody).then(
        (data) => {
          dispatch(createTargetGroupsByVersionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(createTargetGroupsByVersionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function editTargetGroupsByVersion(requestBody, queryParams) {
  function editTargetGroupsByVersionLoad() {
    return {
      type: editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function editTargetGroupsByVersionSuccess(data) {
    return {
      type: editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function editTargetGroupsByVersionFailure(error) {
    return {
      type: editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editTargetGroupsByVersionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVersionService
        .editTargetGroupsByVersion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editTargetGroupsByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editTargetGroupsByVersionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetGroupsByVersion(requestBody, queryParams) {
  function addTargetGroupsByVersionLoad() {
    return {
      type: addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function addTargetGroupsByVersionSuccess(data) {
    return {
      type: addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function addTargetGroupsByVersionFailure(error) {
    return {
      type: addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetGroupsByVersionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVersionService
        .addTargetGroupsByVersion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetGroupsByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(addTargetGroupsByVersionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetGroupsByVersion(queryParams) {
  function removeTargetGroupsByVersionLoad() {
    return {
      type: removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function removeTargetGroupsByVersionSuccess(data) {
    return {
      type: removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function removeTargetGroupsByVersionFailure(error) {
    return {
      type: removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetGroupsByVersionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVersionService.removeTargetGroupsByVersion(queryParams).then(
        (data) => {
          dispatch(removeTargetGroupsByVersionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(removeTargetGroupsByVersionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function deleteTargetGroupsByVersion(queryParams) {
  function deleteTargetGroupsByVersionLoad() {
    return {
      type: deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_LOADING,
    };
  }
  function deleteTargetGroupsByVersionSuccess(data) {
    return {
      type: deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_SUCCESS,
      data,
    };
  }
  function deleteTargetGroupsByVersionFailure(error) {
    return {
      type: deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteTargetGroupsByVersionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVersionService.deleteTargetGroupsByVersion(queryParams).then(
        (data) => {
          dispatch(deleteTargetGroupsByVersionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deleteTargetGroupsByVersionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const targetGroupsByVersionActions = {
  getTargetGroupsByVersion,
  createTargetGroupsByVersion,
  editTargetGroupsByVersion,
  addTargetGroupsByVersion,
  removeTargetGroupsByVersion,
  deleteTargetGroupsByVersion,
};
